import { combineEpics } from 'redux-observable'
import * as authEpic from './authEpic'
import * as getCareEpic from './getCareEpic'
import * as profileEpic from './profileEpic'
import * as redirectEpic from './redirectEpic'
import * as appointmentEpic from './appointmentEpic'
import * as apiEpic from './apiEpic'
import * as paymentEpic from './paymentEpic'
import * as callEpic from './callEpic'
import * as analyticsEpic from './analyticsEpic'
import * as medicalInfoEpic from './medicalInfoEpic'
import * as billingEpic from './billingEpic'
import * as providersEpic from './providersEpic'
import * as localeEpic from './localeEpic'
import * as nhMemberEpic from './nhMemberEpic'

// Use Object.values as otherwise can't destruct properly as the epics are es6 modules
export default combineEpics(
  ...Object.values({
    ...authEpic,
    ...getCareEpic,
    ...profileEpic,
    ...redirectEpic,
    ...apiEpic,
    ...appointmentEpic,
    ...paymentEpic,
    ...callEpic,
    ...analyticsEpic,
    ...medicalInfoEpic,
    ...billingEpic,
    ...providersEpic,
    ...localeEpic,
    ...nhMemberEpic,
  })
)
